<template>
    <div class="container-fluid">
        <h4 class="bg-secondary text-white text-center p-2">Generación y Resolución de Ejercicio Direccionamiento IP con Máscara</h4>
        <div class="form-group">
            <label>Dirección IP:</label>
            <input type="text" class="form-control" v-model="ipaddress">
        </div>
        <div class="form-group">
            <label>Máscara (CIDR):</label>
            <input type="text" class="form-control" v-model="ipmaskcidr">
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio"
                v-model="ipoption" value="B">
            <label class="form-check-label">IP y máscara aleatorias</label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio"
                v-model="ipoption" value="I">
            <label class="form-check-label">IP aleatoria</label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio"
                v-model="ipoption" value="M">
            <label class="form-check-label">Máscara aleatoria</label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio"
                v-model="ipoption" value="N">
            <label class="form-check-label">IP y máscara introducidas</label>
        </div>
        <button class="btn btn-primary" v-on:click="updateAll">Calcular</button>
        <cidr-addressing :ipaddress=ipaddressprop :ipmaskcidr=ipmaskcidrprop initial-value=""></cidr-addressing>
    </div>
</template>

<script>

import CIDRAddressing from "./CIDRAddressing";

var ip = require("ip");

    function generateCIDRMask() {
        return Math.floor(Math.random() * 22) + 8;
    }

    function generateCIDRMaskForIP(ipaddr) {
        var ba = ip.toBuffer(ipaddr);
        var ml = 8;
        if (ba[0] >= 192) {
            ml = 24;
        } else {
            if ((ba[0] >= 128) && (ba[0] < 192)) {
                ml = 16;
            }
        }
        return Math.floor(Math.random() * (30 - ml)) + ml;
    }

    function generateIP(cidr) {
        var pb = 0;
        if (cidr < 16) {
            pb = Math.random() * 125 + 1;
        } else {
            if (cidr < 24) {
                pb = Math.random() * 190 + 1;
            } else {
                pb = Math.random() * 222 + 1;
            }
        }
        var myip = new Buffer([pb, Math.random() * 256, Math.random() * 256, Math.random() * 255]);
        return ip.toString(myip);
    }

export default {
    data: function () {
        return {
            ipaddress: '',
            ipmaskcidr: '',
            ipoption: 'B',
            ipaddressprop: '',
            ipmaskcidrprop: '',
        }
    },
    components: {'cidr-addressing': CIDRAddressing},
    methods: {
        updateAll() {
            if (this.ipoption == 'B') {
                this.ipmaskcidrprop = generateCIDRMask();
                this.ipaddressprop = generateIP(this.ipmaskcidrprop);
            } else {
                if (this.ipoption == 'I') {
                    this.ipmaskcidrprop = this.ipmaskcidr;
                    this.ipaddressprop = generateIP(this.ipmaskcidrprop);
                } else {
                    if (this.ipoption == 'M') {
                        this.ipaddressprop = this.ipaddress;
                        this.ipmaskcidrprop = generateCIDRMaskForIP(this.ipaddress);
                    } else {
                        this.ipaddressprop = this.ipaddress;
                        this.ipmaskcidrprop = this.ipmaskcidr;
                    }
                }
            }
        }
    }
}
</script>